// channelFilters.js

import { isConversationChannel, isTopicChannel, isVoiceVideoChannel } from 'channels/constants/channelTypes';
import { toMillis } from 'channels/utils/channelTime';
import { LIVE_ROOMS_SURFACE_ENABLED } from 'features/liveRoomsSurface';

/**
 * Returns topic channels (TEXT and VOICE_VIDEO).
 * When live rooms are gated off, VOICE_VIDEO rows are omitted from surface lists.
 *
 * @param {Array<object>} channels - Channel rows.
 * @returns {Array<object>} Filtered channels.
 */
export function filterTopicChannels(channels = []) {
  return (Array.isArray(channels) ? channels : []).filter((row) => {
    if (!isTopicChannel(row?.channelType)) return false;
    if (!LIVE_ROOMS_SURFACE_ENABLED && isVoiceVideoChannel(row?.channelType)) return false;
    return true;
  });
}

/**
 * Returns conversation channels only.
 *
 * @param {Array<object>} channels - Channel rows.
 * @returns {Array<object>} Filtered channels.
 */
export function filterConversationChannels(channels = []) {
  return (Array.isArray(channels) ? channels : []).filter((row) => isConversationChannel(row?.channelType));
}

/**
 * Sorts conversations by most recent activity.
 *
 * @param {Array<object>} channels - Conversation channel rows.
 * @returns {Array<object>} Sorted channels.
 */
export function sortConversationsByActivity(channels = []) {
  return [...(Array.isArray(channels) ? channels : [])].sort((a, b) => {
    const aMs = toMillis(a?.lastMessageAt);
    const bMs = toMillis(b?.lastMessageAt);

    if (aMs !== bMs) return bMs - aMs;

    return String(a?.key || '').localeCompare(String(b?.key || ''));
  });
}
